(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var items = document.querySelectorAll('.DT-English-NavItem[data-dt-english-navitem]');
    if (!items || !items.length) return;

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var panel = item.querySelector('[data-dt-english-mega]');
        if (!panel) return;

        function open() {
          item.classList.add('is-mega-open');
          panel.setAttribute('aria-hidden', 'false');
        }

        function close() {
          item.classList.remove('is-mega-open');
          panel.setAttribute('aria-hidden', 'true');
        }

        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);

        var firstLink = item.querySelector('a');
        if (firstLink) {
          firstLink.addEventListener('focus', open);
          item.addEventListener('focusout', function (e) {
            if (!item.contains(e.relatedTarget)) close();
          });
        }
      })(items[i]);
    }
  });
})();
